/** 根类别展示顺序；未列出的根类别按字母序附在后面。 */
export const ROOT_CATEGORY_ORDER = [
  'tops',
  'bottoms',
  'dresses',
  'footwear',
  'accessories',
  'bags',
  'jewelry',
  'other',
] as const;

const ROOT_CATEGORY_LABELS_ZH: Record<string, string> = {
  tops: '上装',
  bottoms: '下装',
  dresses: '连衣裙',
  footwear: '鞋履',
  accessories: '配饰',
  bags: '包袋',
  jewelry: '珠宝',
  other: '其他',
};

/** 取 category 路径根段（第一个 `.` 前），如 `tops.inner_tops` → `tops` */
export function categoryRoot(category?: string): string {
  const raw = (category || '').trim().toLowerCase();
  if (!raw) return 'other';
  const root = raw.split('.')[0]?.trim();
  return root || 'other';
}

export function rootCategoryLabel(root: string): string {
  return ROOT_CATEGORY_LABELS_ZH[root] || root;
}

export function rootCategoryRank(root: string): number {
  const idx = (ROOT_CATEGORY_ORDER as readonly string[]).indexOf(root);
  return idx >= 0 ? idx : ROOT_CATEGORY_ORDER.length;
}

export function compareWardrobeCategory(a?: string, b?: string): number {
  const ra = categoryRoot(a);
  const rb = categoryRoot(b);
  const rank = rootCategoryRank(ra) - rootCategoryRank(rb);
  if (rank !== 0) return rank;
  return (a || '').localeCompare(b || '', 'zh');
}

export function presentRootCategories(categories: Iterable<string | undefined>): string[] {
  const present = new Set<string>();
  for (const c of categories) present.add(categoryRoot(c));
  const preferred = ROOT_CATEGORY_ORDER.filter(r => present.has(r));
  const rest = [...present]
    .filter(r => !(ROOT_CATEGORY_ORDER as readonly string[]).includes(r))
    .sort((a, b) => a.localeCompare(b));
  return [...preferred, ...rest];
}
